const cardItems = [
  {
    id: 1,
    title: '暑期档最值得追的10部剧',
    desc: '从古装巨制到现代都市，精选本季口碑最佳的电视剧清单，陪你度过炎炎夏日。',
    tag: '追剧指南',
    image: 'https://readdy.ai/api/search-image?query=Summer%20drama%20series%20collage%20with%20warm%20coral%20and%20golden%20lighting%2C%20elegant%20Chinese%20costume%20drama%20aesthetic%2C%20cinematic%20composition%2C%20soft%20dreamy%20atmosphere&width=600&height=400&seq=mitao-card-1&orientation=landscape',
  },
  {
    id: 2,
    title: '豆瓣8分以上悬疑电影推荐',
    desc: '高分悬疑片单整理，烧脑剧情层层反转，每一部都经得起推敲的推理佳作。',
    tag: '电影推荐',
    image: 'https://readdy.ai/api/search-image?query=Mystery%20film%20atmosphere%20with%20warm%20dramatic%20shadows%2C%20film%20noir%20lighting%2C%20golden%20amber%20tones%2C%20suspenseful%20cinematic%20mood%2C%20elegant%20dark%20aesthetic&width=600&height=400&seq=mitao-card-2&orientation=landscape',
  },
  {
    id: 3,
    title: '国漫崛起：这些作品值得追',
    desc: '国产动漫精品盘点，从玄幻修仙到科幻未来，见证国漫的飞速进步。',
    tag: '动漫专区',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20art%20with%20warm%20vibrant%20colors%2C%20modern%20anime%20style%20illustration%2C%20coral%20and%20golden%20lighting%2C%20fantasy%20elements%2C%20artistic%20composition&width=600&height=400&seq=mitao-card-3&orientation=landscape',
  },
  {
    id: 4,
    title: '周末观影：喜剧电影精选',
    desc: '轻松愉快的喜剧电影推荐，从国产到好莱坞，给你一个欢乐的周末时光。',
    tag: '周末片单',
    image: 'https://readdy.ai/api/search-image?query=Comedy%20movie%20scene%20with%20warm%20cheerful%20lighting%2C%20bright%20living%20room%20setting%2C%20golden%20hour%20glow%2C%20happy%20atmosphere%2C%20cozy%20entertainment%20aesthetic&width=600&height=400&seq=mitao-card-4&orientation=landscape',
  },
  {
    id: 5,
    title: '科幻迷必看：硬核科幻片单',
    desc: '从经典到新作，整理了一份科幻迷不可错过的硬核科幻电影清单。',
    tag: '科幻专题',
    image: 'https://readdy.ai/api/search-image?query=Science%20fiction%20cinematic%20scene%20with%20warm%20futuristic%20lighting%2C%20space%20and%20technology%20elements%2C%20golden%20and%20coral%20color%20palette%2C%20epic%20composition%2C%20modern%20sci-fi%20aesthetic&width=600&height=400&seq=mitao-card-5&orientation=landscape',
  },
  {
    id: 6,
    title: '纪录片：打开世界的另一种方式',
    desc: '精选自然、人文、历史类高分纪录片，用镜头探索世界的广袤与奇妙。',
    tag: '纪录精选',
    image: 'https://readdy.ai/api/search-image?query=Documentary%20style%20nature%20scene%20with%20warm%20golden%20sunset%20lighting%2C%20vast%20landscape%20photography%2C%20earthy%20warm%20tones%2C%20cinematic%20composition%2C%20exploration%20aesthetic&width=600&height=400&seq=mitao-card-6&orientation=landscape',
  },
];

export default function Cards() {
  return (
    <section id="cards" className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4">
            <i className="ri-layout-grid-line"></i>
            <span>编辑推荐</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            精选推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-600 mt-3 max-w-lg mx-auto">
            精心挑选的优质内容推荐，总有一款适合你
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cardItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <span className="inline-block px-2.5 py-1 rounded-md bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
                  {item.tag}
                </span>
                <h3 className="text-sm font-semibold text-foreground-900 mb-2 leading-snug">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}